<i18n lang="yaml">
ru:
  select_distributor: 'Выберите дистрибьютора'
en:
  select_distributor: 'Select distributor'
</i18n>


<template>
  <div class="filter-elem1" v-click-outside="toggleSwitchClose">
    <span>{{ $t('select_distributor') }}</span>
    <div class="dropdown field" @click="toggleSwitch">
      <input :value="selectedDistr ? selectedDistr : emptyDistr" readonly/>
      <button>
        <i class="svg-icon arrow-bold" :class="{'rotate-180': active}"></i>
      </button>
    </div>
    <slide-up-down :active="active" :duration="400" :responsive="true"
                   class="filter-obj-list" 
                   @close-end="changeDistr">
        <div ref="distr_list" class="object-list">
          <div v-if="distributor">
            <a href="#" @click.prevent="selectDistr(null)">
              <span class="distr-elem">{{ emptyDistr }}</span>
            </a>
          </div>
          <div v-for="distr in distributors">
            <a href="#" @click.prevent="selectDistr(distr)">
              <span class="city-elem">{{ distr }}</span>
            </a>
          </div>
        </div>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: {
    SlideUpDown,
  },
  props: ['distributors', 'distributor'],
  data() {
    return {
      active: false,
      emptyDistr: 'Все дистрибьюторы',
      selectedDistr: this.distributor,
    }
  },
  watch: {
    city(val) {
      this.selectedDistr = val;
    },
  },
  methods: {
    toggleSwitch() {
      this.active = !this.active;
    },
    toggleSwitchClose() {
      if (this.active) {
        this.active = false;
      }
    },
    changeDistr() {
      this.$emit('change', this.selectedDistr);
      if (this.$refs.distr_list) {
        this.$refs.distr_list.offsetParent.scrollTop = 0;
      }
    },
    selectDistr(distr) {
      this.selectedDistr = distr;
      this.toggleSwitch();
    },
  },
}
</script>
